<template>
	<div>
		<h5>AutomaticFaceRecognition</h5>
	</div>
</template>

<script>
	export default {
		name: "AutomaticFaceRecognition",
	};
</script>

<style scoped></style>
